import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'
import {config} from 'services/config'
import {prepareHeaders} from "./index";
import {IFeedback, IProject} from "models/project";


export const projectAPI = createApi({
    reducerPath: 'projectAPI',
    baseQuery: fetchBaseQuery({
        baseUrl: config.BASE_URL,
        prepareHeaders: prepareHeaders,
    }),
    tagTypes: ['Feedbacks', 'Projects'],
    endpoints: (builder) => ({
        addFeedback: builder.mutation<IFeedback, Partial<IFeedback>>({
            query: (args: Partial<IFeedback>) => {
                return {
                    url: '/feedbacks/',
                    method: 'POST',
                    body: {
                        author: args.author,
                        comment: args.comment,
                    },
                    headers: {
                        'Content-Type': 'application/json',
                    },
                };
            },
            invalidatesTags: ['Projects'],
        }),
        getProjects: builder.query<IProject[], void>({
            query: () => ({
                url: `/projects/`,
                method: 'GET'
            }),
            providesTags: (result) =>
                result
                    ? [
                        ...result.map(({id}) => ({type: 'Projects' as const, id})),
                        {type: 'Projects', id: 'LIST'},
                    ]
                    : [{type: 'Projects', id: 'LIST'}],
        }),
        addProject: builder.mutation<IProject, Partial<IProject>>({
            query: (args: Partial<IProject>) => {
                return {
                    url: '/projects/',
                    method: 'POST',
                    body: args,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                };
            },
            invalidatesTags: [{type: 'Projects', id: 'LIST'}],
        }),
        updatePartialProject: builder.mutation<IProject, Partial<IProject>>({
            query: (args) => ({
                url: `/projects/${args.id}/`,
                method: 'PATCH',
                body: args
            }),
            invalidatesTags: (result, _error, arg) => [{type: 'Projects', id: result?.id ?? arg.id}]
        }),
        updateProjectName: builder.mutation<IProject, { id: string; name: string }>({
            query: ({ id, name }) => ({
                url: `/projects/${id}/update-name/`,
                method: 'PATCH',
                body: { name },
                headers: { 'Content-Type': 'application/json' },
            }),
            invalidatesTags: (result, _error, arg) => [{ type: 'Projects', id: result?.id ?? arg.id }],
        }),
        deleteProject: builder.mutation({
            query: (id: string) => ({
                url: `/projects/${id}/`,
                method: 'DELETE'
            }),
            invalidatesTags: (result, error, id) => [{type: 'Projects', id}],
        }),
        generateCircuit: builder.mutation<string, any>({
            query: (args: {slider_value: number, stator_params: any}) => {
                return {
                    url: '/projects/genera_circuit_with_data/',
                    method: 'POST',
                    body: args,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                };
            },
        }),
    })
})
export const {
    useAddFeedbackMutation,
    useAddProjectMutation,
    useGetProjectsQuery,
    useDeleteProjectMutation,
    useGenerateCircuitMutation,
    useUpdatePartialProjectMutation,
    useUpdateProjectNameMutation,
} = projectAPI
